import { connect } from 'react-redux';
import ShareEstimateMessage from './ShareEstimateMessage';

const mapStateToProps = ({ estimateBuilder }) => {
  const selectedEstimate =
    estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate];
  return {
    email: selectedEstimate.sharedEmail,
    sharedDate: selectedEstimate.sharedDate,
  };
};

export default connect(mapStateToProps)(ShareEstimateMessage);
